import {faArrowTurnDown, faList, faListNumeric} from '@fortawesome/pro-regular-svg-icons'

import {FaIcon} from '@sdox/ui'

import {EditorFeature} from '../types'
import {EditorControlButton} from './EditorControlButton'
import {useTipTapEditorContext} from '../EditorContext'
import {ControlGroup} from './ControlGroup'

const features = [
  EditorFeature.orderedList,
  EditorFeature.bulletList,
  EditorFeature.linebreak,
]

export const ThirdControlGroup = () => {
  const {editor} = useTipTapEditorContext()

  return (
    <ControlGroup features={features}>
      <EditorControlButton
        active={editor.isActive('orderedList')}
        feature={EditorFeature.orderedList}
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        trailing={<FaIcon icon={faListNumeric} />}
        title={'Add ordered list'}
      />
      <EditorControlButton
        active={editor.isActive('bulletList')}
        feature={EditorFeature.bulletList}
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        trailing={<FaIcon icon={faList} />}
        title={'Add bullet list'}
      />
      <EditorControlButton
        feature={EditorFeature.linebreak}
        onClick={() => editor.chain().focus().setHardBreak().run()}
        trailing={(
          <FaIcon
            icon={faArrowTurnDown}
            className={'rotate-90'}
          />
        )}
        title={'Add hard break'}
      />
    </ControlGroup>
  )
}
